import React from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import { flatMappedStories } from 'pages/currentawareness/Util'
import HomepageStoriesContainer from 'redux/containers/pages/dashboard/HomepageStoriesContainer'

const StoriesWrapper = ({ homepageArticles }) => (
  <ResponseConsumer
    response={homepageArticles}
    content={() => <HomepageStoriesContainer stories={flatMappedStories(homepageArticles)} />}
  />
)

export default StoriesWrapper
